import { LoginQrPage } from "./../login-qr/login-qr";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  LoadingController,
  NavParams,
} from "ionic-angular";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
// import { LoginSyncPlatformPage } from "../login-sync-platform/login-sync-platform";
import { SelectLanguagePage } from "../select-language/select-language";
import { Location } from "@angular/common";

@IonicPage()
@Component({
  selector: "page-login",
  templateUrl: "login.html",
})
export class LoginPage {
  private login: FormGroup;
  theme = 1;

  constructor(
    private services: ServiceProvider,
    private formBuilder: FormBuilder,
    private http: Http,
    private storage: Storage,
    public navCtrl: NavController,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController,
    private location: Location
  ) {
    const url = window.location.href;
    const queryParams = this.getQueryParams(url);

    this.login = this.formBuilder.group({
      username: [
        queryParams["username"] ? queryParams["username"] : "",
        Validators.compose([Validators.required]),
      ],
      password: [
        queryParams["password"] ? queryParams["password"] : "",
        Validators.compose([Validators.required]),
      ],
    });
  }

  getQueryParams(url: string): { [key: string]: string } {
    const queryParams: { [key: string]: string } = {};
    const queryString = url.split("?")[1];
    if (queryString) {
      const pairs = queryString.split("&");
      pairs.forEach((pair) => {
        const [key, value] = pair.split("=");
        queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
      });
    }
    return queryParams;
  }

  ionViewDidLoad() {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();
    var link = this.services.URLThemeSetting;
    this.http
      .get(link)
      .map((res) => res.json())
      .subscribe(
        (data) => {
          if (data.GAME_THEME) {
            this.theme = data.GAME_THEME;
            // console.log("GAME_THEME===>", data.GAME_THEME);
          }
          loader.dismiss();
        },
        (error) => {
          var response = JSON.parse(error._body);
          loader.dismiss();
          this.translateService.get(response.message).subscribe((value) => {
            this.services.presentToast(value);
          });
        }
      );

    // console.log('ionViewDidLoad LoginPage');
  }

  Login() {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });

    let dataVal = this.login.value;

    if (!dataVal.username || !dataVal.password) {
      this.translateService.get("error blank").subscribe((value) => {
        this.services.presentToast(value);
      });
      return false;
    } else {
      loader.present();

      var link = this.services.URLAuthen;

      var postData = JSON.stringify({
        grant_type: "password",
        username: dataVal.username, //'admin@api.loc'
        password: dataVal.password, //123123123
        client_id: "the-plaza",
        client_secret: "onHtIz4owSNWgcEd7JELw2X-0vG8c02w",
        scope: "custom",
      });

      this.http
        .post(link, postData, this.services.getHeaderAuthen())
        .map((res) => res.json())
        .subscribe(
          (data) => {
            if (
              this.storage.set("token", data.access_token) &&
              this.storage.set("roundGame", 1) &&
              this.storage.set("stepGame", "selectLang")
            ) {
              var link = this.services.URLUserInfo;
              var headers = new Headers();
              headers.append("Accept", "application/json");
              headers.append("Authorization", "Bearer " + data.access_token);
              const requestOptions = new RequestOptions({
                headers: headers,
              });

              this.http
                .get(link, requestOptions)
                .map((res) => res.json())
                .subscribe(
                  (res) => {
                    this.storage.set("info", res);
                    this.storage.set("theme", res.section.theme_id);
                    this.navCtrl.setRoot(SelectLanguagePage);
                  },
                  (error) => {
                    var response = JSON.parse(error._body);
                    this.translateService
                      .get(response.message)
                      .subscribe((value) => {
                        this.services.presentToast(value);
                      });
                  }
                );

              loader.dismiss();
              // this.navCtrl.setRoot(SelectLanguagePage);
            }
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    }
  }

  LoginQR() {
    this.navCtrl.push(LoginQrPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts